<div *ngIf="deeplinks?.length > 0" class="border-top pr-small">
  <h3 class="bold-type font-heading-4">
    {{ 'MMB.thirdparty.mmbViewPnr.header' | finLocalization: { destinationCity } }}
  </h3>
  <div class="flex ms-medium-t third-party-row">
    <div *ngFor="let deeplink of deeplinks" class="flex-1 flex--basis-half">
      <div class="flex" [attr.data-testid]="'deeplink-' + deeplink.partner">
        <div class="flex--nogrow pr-xsmall-r">
          <fcom-icon class="icon-xlarge" [name]="deeplink.partnerIcon"></fcom-icon>
        </div>
        <div class="flex-4">
          <p>{{ 'MMB.thirdparty.mmbViewPnr.' + deeplink.cmsKey + '.description' | finLocalization }}</p>
          <fcom-link
            [href]="deeplink.url"
            [external]="true"
            [openInNewTab]="true"
            (beforeNavigation)="trackClick(deeplink)"
          >
            {{ 'MMB.thirdparty.mmbViewPnr.' + deeplink.cmsKey + '.linkText' | finLocalization }}
          </fcom-link>
        </div>
      </div>
    </div>
  </div>
</div>
